export const sortByDate = (array, field, isDesc = true) => {
    return array.sort((a, b) => {
        const _isDesc = isDesc ? 1 : -1;
        return (getUnixDateField(field, a) > getUnixDateField(field, b) ? -1 : 1) * _isDesc;
    });
};
function getUnixDateField(field, obj) {
    const date = (typeof field === 'function' ? field(obj) : obj[field]);
    if (date instanceof Date) {
        return date.getTime();
    }
    if (typeof date === 'number') {
        return date;
    }
    return new Date(date).getTime();
}
